
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"レイヤー 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 64 64"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticStyle:{"isolation":"isolate"},attrs:{"data-name":"Path 447","d":"M32 10.1A34.42 34.42 0 000 32a34.33 34.33 0 0064 0 34.42 34.42 0 00-32-21.9zm0 36.49a14.6 14.6 0 1114.55-14.65A14.58 14.58 0 0132 46.59zm0-23.36A8.76 8.76 0 1040.73 32 8.73 8.73 0 0032 23.24z"}})])
          )
        }
      }
    